/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import TopTitlePage from '../../components/TopTitlePage'
import { Button, Card, Container, Form, Offcanvas, Row } from 'react-bootstrap'
import Loading from '../../components/Loading'
import { SweetAlert } from '../../components/sweetalert'

import ReactPaginate from 'react-paginate';
import './style.css'
import { useForm } from 'react-hook-form'
import { useAuth } from '../../context/auth'
import { URL as URL1 } from '../../config/url'
import { useNavigate } from 'react-router-dom'
import Financeiro from '../../services/Financeiro'
import ButtonFilterAndSelect from '../../components/ButtonFilterAndSelect'
import ButtonLimparAndFiltrar from '../../components/ButtonLimparAndFiltrar'
import TableList from '../../components/TableComponents/TableList'
import InputPaciente from '../../components/Inputs/InputPaciente'
import InputTecnico from '../../components/Inputs/InputTecnico'
import TableData from './TableData'
import { formatMoneySemR$ } from '../../utilities/formatMoneyValue'
import InputSearchName from '../../components/InputSearchName'
import SessionsServices from '../../services/sessions'
import { getUserPeriod } from '../../utilities/financialPeriod'

import { format, startOfMonth, endOfMonth } from 'date-fns'

// Sem a permissão "Valor total do Financeiro" (cadastro do usuário), o backend não manda a soma: null esconde o valor
const formatTotal = (analytics) => (analytics?.total_financeiro === undefined ? null : formatMoneySemR$(analytics.total_financeiro))

const ListaFinanceiros = () => {

  const { register, getValues, handleSubmit, setValue } = useForm()
  const { user } = useAuth()

  // Usuário relido do /sessions/me ao abrir a tela: o período do Financeiro pode ter mudado depois do login.
  // Estado local, e não setUser: com o RequireAuth declarado dentro do Router, cada setUser remonta esta tela.
  const [currentUser, setCurrentUser] = useState(user)

  // Janela do usuário (null = sem restrição), recalculada a cada render
  const period = getUserPeriod(currentUser)
  const restricted = period !== null

  const navigate = useNavigate()

  const [financeiros, setFinanceiros] = useState([])
  const [loading, setLoading] = useState(false)

  const [, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [totalValor, setTotalValor] = useState('R$ 0.00');

  const [show, setShow] = useState(false);
  const [filter, setFilter] = useState(false);

  useEffect(() => {
    setLoading(true)
    SessionsServices.perfil()
      .then(({ data }) => {
        setCurrentUser(data)
        return data
      })
      .catch(() => user)
      .then((userData) => listAllFinanceiros(1, true, userData)) // o estado novo só vale no próximo render
  }, []);


  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Datas da busca. Restrito: a janela calculada agora, e os campos travados acompanham.
  // Sem restrição: as datas do formulário, como antes.
  function searchDates(values) {
    const userPeriod = getUserPeriod(currentUser)
    if (!userPeriod) return { data_inicial: values.data_inicial ?? '', data_final: values.data_final ?? '' }

    setValue('data_inicial', userPeriod.data_inicial);
    setValue('data_final', userPeriod.data_final);
    return userPeriod
  }

  function listAllFinanceiros(pageNumber, filtroDefault = false, userData = currentUser) {
    setLoading(true);

    const values = getValues()
    const today = new Date()
    let newFiltro

    if (filtroDefault === true) {
      // Restrito: a janela do usuário no lugar do mês corrente
      const dates = getUserPeriod(userData) ?? { data_inicial: format(startOfMonth(today), 'yyyy-MM-dd'), data_final: format(endOfMonth(today), 'yyyy-MM-dd') }

      newFiltro = {
        ...dates,
        tecnico_id: userData.tecnico?.id,
      }
      setValue('data_inicial', dates.data_inicial);
      setValue('data_final', dates.data_final);
      setValue('tecnico_id', userData.tecnico?.id);
      setValue('tecnico', userData.tecnico?.nome);

    } else {
      newFiltro = {
        paciente_id: values.paciente_id ?? '',
        tecnico_id: values.tecnico_id ?? '',
        ...searchDates(values),
      }
    }

    Financeiro.listAll(pageNumber, newFiltro)
      .then((data) => {
        setFinanceiros(data.data.data);
        setTotalPages(data.data.paging.total_pages)
        setTotalRegistros(data.data.paging.total_records)
        setTotalValor(formatTotal(data.data.analytics))
      })
      .catch((error) => {
        SweetAlert.error(error?.response?.data?.message ?? error?.message, 'Financeiros');
      })
      .finally(() => {
        // setFiltros(newFiltro)
        setLoading(false)
      });
  }

  function listFilterName(pageNumber) {
    setLoading(true);

    const values = getValues()

    let newFiltro = {
      paciente_nome: values.nome_input ?? '',
      // Restrito: a busca por nome também leva a janela
      ...(restricted && searchDates(values)),
    }

    Financeiro.listAll(pageNumber, newFiltro)
      .then((data) => {
        setFinanceiros(data.data.data);
        setTotalPages(data.data.paging.total_pages)
        setTotalRegistros(data.data.paging.total_records)
        setTotalValor(formatTotal(data.data.analytics))
      })
      .catch((error) => {
        SweetAlert.error(error?.response?.data?.message ?? error?.message, 'Financeiros');
      })
      .finally(() => {
        // setFiltros(newFiltro)
        setLoading(false)
      });
  }


  const handlePageChange = (selected) => {
    setPage(selected.selected + 1)
    // Com o nome preenchido, pagina a busca por nome; senão, os filtros do Offcanvas
    if (getValues('nome_input')) {

      listFilterName(selected.selected + 1);
    } else {

      listAllFinanceiros(selected.selected + 1);
    }
  };

  function onFilter() {

    setFilter(true)

    setShow(false)
    listAllFinanceiros(1)
  }

  function deleteFinanceiro(id) {
    setLoading(true)
    Financeiro.delete(id)
      .then((data) => {
        SweetAlert.success('Financeiro deletado com sucesso!', 'Financeiro');
        listAllFinanceiros()
      })
      .catch((error) => {
        console.log(error)
        SweetAlert.error(error?.response?.data?.message, 'Financeiro');
      })
      .finally(() => setLoading(false))
  }

  function deleteContratoAlert(id) {
    SweetAlert.question('Atenção', 'Deletar financeiro?', 'SIM!', () => deleteFinanceiro(id), '#FF0000')
  }

  function editContrato(id) {
    navigate(URL1.financeiro_cadastro + '/' + id)
  }

  function cleanFilter() {
    const today = new Date()
    // Restrito: volta para a janela do usuário, e não para o mês corrente
    const dates = getUserPeriod(currentUser) ?? { data_inicial: format(startOfMonth(today), 'yyyy-MM-dd'), data_final: format(endOfMonth(today), 'yyyy-MM-dd') }
    setValue('data_inicial', dates.data_inicial);
    setValue('data_final', dates.data_final);
    setValue('codigo', '')
    setValue('paciente_id', '')
    setValue('paciente', '')
    setValue('tecnico', '')
    setValue('tecnico_id', '')
  }

  return (
    <>
      {loading === true ? <Loading /> : ''}

      <Offcanvas show={show} onHide={handleClose} style={{ height: '100vh', backgroundColor: 'var(--app-panel-bg)' }} placement='bottom'>
        <Form onSubmit={handleSubmit(onFilter)}>
          <Container>
            <Offcanvas.Header closeButton>
              <TopTitlePage title='Filtro' />
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Card className='cardShadow'>
                <Card.Body className='p-3'>

                  {/* Restrito: datas travadas com o atributo disabled, que mantém o valor no formulário */}
                  <Row className='d-flex align-items-end'>
                    <Form.Group className="col-12 col-lg-3">
                      <Form.Label>Data inicial</Form.Label>
                      <Form.Control
                        size='sm'
                        type="date"
                        {...register('data_inicial')}
                        disabled={restricted}
                      />
                    </Form.Group>

                    <Form.Group className="col-12 col-lg-3">
                      <Form.Label>Data final</Form.Label>
                      <Form.Control
                        size='sm'
                        type="date"
                        {...register('data_final')}
                        disabled={restricted}
                      />
                    </Form.Group>
                  </Row>
                  {restricted && <small style={{ color: 'red' }}>* Período definido no cadastro do seu usuário.</small>}

                  <Row className='d-flex align-items-end mt-2'>
                    <InputPaciente
                      setValue={setValue}
                      loading={loading}
                      setLoading={setLoading}
                      // setPhoto=''
                      getValues={getValues}
                      register={register}
                    />

                  </Row>

                  <Row className='d-flex align-items-end mt-2'>
                    <InputTecnico
                      setValue={setValue}
                      loading={loading}
                      setLoading={setLoading}
                      getValues={getValues}
                      register={register}
                    />

                  </Row>

                </Card.Body>
              </Card>
              <div className='d-flex justify-content-end mt-3 gap-3'>
                <ButtonLimparAndFiltrar
                  handleClose={handleClose}
                  reset={cleanFilter}
                  listAll={listAllFinanceiros}
                  setFilter={setFilter}
                />
              </div>
            </Offcanvas.Body>
          </Container>
        </Form>
      </Offcanvas>

      <div>
        <TopTitlePage title='Financeiros' />

        <div className='py-3 d-flex justify-content-between px-3 align-items-end gap-2 flex-column flex-md-row'>

          <ButtonFilterAndSelect
            handleShow={handleShow}
            listAll={listAllFinanceiros}
            filter={filter}
          />


          <div className='d-flex align-items-end col-12 col-md-auto'>
            <Button
              variant='success'
              onClick={() => navigate(URL1.financeiro_cadastro)}
              className='col-12 col-md-auto'
            >+ Novo Financeiro</Button>
          </div>
        </div>

        <div className='mx-3 mb-2 lg-mb-0'>

          <InputSearchName
            register={register}
            listAll={listAllFinanceiros}
            listFilterName={listFilterName}

          />

        </div>

        <Card className='mx-3 cardShadow mb-2 lg-mb-0' >
          <Card.Body className='p-0'>

            {financeiros.length === 0 ?
              <div className='d-flex justify-content-center py-2'>
                <h4>Sem registros</h4>
              </div>
              :
              <>
                <TableList>
                  <TableData
                    array={financeiros}
                    editFunction={editContrato}
                    deleteFunction={deleteContratoAlert}
                  />
                </TableList>

                <div className='mt-4 d-flex justify-content-between px-3 flex-column flex-md-row gap-3'>
                  <div className='d-flex gap-3 flex-column flex-md-row'>
                    <span> Total: {totalRegistros}</span>
                  </div>
                  {totalValor !== null && <span> Valor total: R$ {totalValor}</span>}
                  <ReactPaginate
                    pageCount={totalPages}
                    pageRangeDisplayed={1}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={'pagination_container'}
                    activeClassName={'active'}
                    previousLabel={'<'}
                    nextLabel={'>'}
                  />
                </div>
              </>
            }


          </Card.Body>
        </Card>



      </div>
    </>
  )
}

export default ListaFinanceiros